import React from 'react';
import useQueues from 'hooks/useQueues';
import { useQueueChatPauseContext } from 'hooks/useQueuePauseChatServicePanel';
import { useMemo } from 'react';
import { Col, Row } from 'reactstrap';
import AgentConversationInfo from '../../AgentIndicators/components/AgentConversationInfo';
import ChatsAnswers from '../../AgentIndicators/components/ChatsAnswers';
import QueueList from '../../AgentIndicators/components/QueueList';
import TMACardChat from '../../AgentIndicators/components/TMACardChat';
import TMFirstMessage from '../../AgentIndicators/components/TMFirstMessage';
import TextInformative from 'components/TextInformative';
/**
 * @typedef {Object} Queue
 * @property {number} id
 * @property {number} timeout
 * @property {string|null} musiconhold
 * @property {number} wrapuptime
 * @property {boolean} autopause
 * @property {boolean} ringinuse
 * @property {string} strategy
 * @property {string} name
 * @property {string|null} periodic_announce
 * @property {number} periodic_announce_frequency
 * @property {boolean} fila_personalizada
 * @property {string|null} foraHorario
 * @property {boolean} disable
 * @property {number|null} announceFrequency
 * @property {number|null} announcePosition
 * @property {string} closing_message
 * @property {boolean} closing_message_enabled
 * @property {string} greeting_message
 * @property {boolean} greeting_message_enabled
 * @property {string} transfer_message
 * @property {boolean} transfer_message_enabled
 * @property {boolean} send_attendant_name
 * @property {string} strategy_chat
 * @property {number} max_chat_per_user
 * @property {string|null} chat_overflow
 * @property {string|null} queue_of_chat_overflow
 * @property {string} message_of_chat_overflow
 * @property {boolean} active_chat_in_chat_distribution
 * @property {number} scheduleTime_id
 * @property {number} centrodecustoId
 * @property {number|null} callback_id
 * @property {string} color
 * @property {boolean} is_chat
 * @property {boolean} is_telephony
 * @property {number} levelOfService
 * @property {Object} centrodecusto
 * @property {number} centrodecusto.id
 * @property {string} centrodecusto.name
 * @property {string} centrodecusto.description
 */


const ChatTab = ({ dashboardChatIndividually }) => {
  // As informações de todas as filas de chat
  /** @type {{ response: Queue[]}} */
  const { response: chatQueues } = useQueues({ types: ["is_chat"] })

  /** 
   * IDs das filas de chat que estão logadas no momento
   * @type {{queuesChatLoggedValues: number[]}}
  */
  const { queuesChatLoggedValues } = useQueueChatPauseContext();

  /** As filas de chat que estão logadas, mas com todas as informações ao invés de apenas ID */
  const loggedQueues = useMemo(() => chatQueues.filter(q => queuesChatLoggedValues.includes(q.id)), [chatQueues, queuesChatLoggedValues])

  return (
    <>
      <Row xl="12">
        <Col xl="12" className="mb-4 ml-4">
          <TextInformative text="Dados referentes ao mês atual." />
        </Col>
        <Col xl="6">
          <Col xl="6">
            <ChatsAnswers data={dashboardChatIndividually.totalChatsAnswers} />
          </Col>
          <Col xl="6">
            <TMACardChat data={dashboardChatIndividually.averageServiceTime} />
          </Col>
          <Col xl="6">
            <TMFirstMessage
              data={dashboardChatIndividually.averageFirstResponseTime}
            />
          </Col>
        </Col>
        <Col xl="6">
          <QueueList
            data={
              loggedQueues.map(({ id, name }) => ({
                id,
                name
              })) || []
            }
          />
        </Col>
      </Row>
      <Row>
        <Col xl="12">
          <AgentConversationInfo />
        </Col>
      </Row>
    </>
  );
};

export default ChatTab;
